"use client";

import React from "react";
import SectionLayout from "../ui/SectionLayout";
import { SectionProps } from "./model";
import { getDefaultCmsSection } from "@/utils/helper";
import StackedContentComponent from "../ui/StackedContentComponent";
import { getGap } from "@/utils/theme-helper";

const ImageContentSectionComponent: React.FC<
  SectionProps<{
    content: any;
    gap: "xs" | "sm" | "md" | "lg" | "xl";
    image: {
      url: string;
      width: string;
      desktopPosition: "left" | "right";
      mobilePosition: "top" | "bottom";
    };
  }>
> = ({ cmsSection, index, cmsData, app }) => {
  return (
    <SectionLayout
      cmsSection={getDefaultCmsSection(cmsSection, {
        width: "4xl",
        padding: "none",
      })}
    >
      <style>
        {`.section-${index}  {
          --image-height: ${cmsSection.ui.height};
          --image-width: ${(parseFloat(cmsSection.specifics.image?.width.split("/")[0]) / parseFloat(cmsSection.specifics.image?.width.split("/")[1])) * 100}%;
          --content-width: ${(parseFloat(cmsSection.specifics.content?.width.split("/")[0]) / parseFloat(cmsSection.specifics.content?.width.split("/")[1])) * 100}%;
              }`}
      </style>
      <div
        className={`flex flex-1 h-full section-${index} ${getGap(cmsSection.specifics.gap)}
         ${
           cmsSection.specifics.image?.mobilePosition === "bottom"
             ? "flex-col"
             : "flex-col-reverse"
         }
        ${
          cmsSection.specifics.image?.desktopPosition === "left"
            ? "md:flex-row-reverse"
            : "md:flex-row"
        }`}
      >
        <div className="w-full md:w-[var(--content-width)] homepage-text-lg flex">
          <StackedContentComponent
            cmsData={cmsData}
            config={cmsSection.specifics.content}
            index={index}
            cmsSection={cmsSection}
            app={app}
          />
        </div>
        <div className="relative flex h-[var(--image-height)] md:h-full w-full md:w-[var(--image-width)]">
          <img
            alt="Image"
            src={cmsSection.specifics.image?.url}
            className="object-cover h-full w-full"
          />
        </div>
      </div>
    </SectionLayout>
  );
};

export default ImageContentSectionComponent;
